export const coOrdersTable = [
  {
    source: 'order_id',
    sortable: true,
    title: 'Id',
    selectable: true,
  },
  {
    source: 'order_assembly_type',
    sortable: true,
    title: 'Type',
    selectable: true,
  },
  {
    source: 'order_assembly_style',
    sortable: true,
    title: 'Style',
    selectable: true,
  },
  {
    source: 'order_assembly_urgency',
    sortable: true,
    title: 'Urgency',
    selectable: true,
  },
  {
    source: 'order_marketplace_sold_date',
    sortable: true,
    title: 'Date',
    selectable: true,
  },
  {
    source: 'order_status',
    sortable: true,
    title: 'Status',
    selectable: true,
  },
  {
    source: 'order_item_mpn',
    sortable: true,
    title: 'Mpn',
    selectable: true,
  },
  {
    source: 'order_car_lift_position',
    sortable: false,
    title: 'Lift position',
    selectable: true,
  },
  {
    source: 'order_notes',
    sortable: false,
    title: 'Notes',
    selectable: true,
  },
  {
    source: 'order_listing_car_make',
    sortable: true,
    title: 'Make',
    selectable: true,
  },
  {
    source: 'order_listing_car_model',
    sortable: true,
    title: 'Model',
    selectable: true,
  },
  {
    source: 'order_listing_car_year_range',
    sortable: true,
    title: 'Years',
    selectable: true,
  },
  {
    source: 'order_label_file',
    sortable: false,
    title: 'Label',
    selectable: true,
  },
  {
    source: 'order_label_file2',
    sortable: false,
    title: 'Label2',
    selectable: true,
  },
  {
    source: 'order_assembly_invoice',
    sortable: false,
    title: 'Invoice',
    selectable: true,
  },
  {
    source: 'order_reference_no',
    sortable: true,
    title: 'Reference no',
    selectable: true,
  },
  {
    source: 'order_shipment_tracking_number',
    sortable: false,
    title: 'Tracking',
    selectable: true,
  },
  {
    source: 'order_assembly_supplier',
    sortable: true,
    title: 'Supplier',
    selectable: true,
  },
  {
    source: 'order_part_box_by',
    sortable: true,
    title: 'Part Box by',
    selectable: true,
  },
  {
    source: 'order_picked_by',
    sortable: true,
    title: 'Picked by',
    selectable: true,
  },
  {
    source: 'order_assembled_by',
    sortable: true,
    title: 'Assembled by',
    selectable: true,
  },
  {
    source: 'order_packed_by',
    sortable: true,
    title: 'Packed by',
    selectable: true,
  },
  {
    source: 'order_picked_date',
    sortable: true,
    title: 'Picked On Date',
    selectable: true,
  },
  {
    source: 'order_assembled_date',
    sortable: true,
    title: 'Assembled On Date',
    selectable: true,
  },
  {
    source: 'order_eta_date',
    sortable: false,
    title: 'ETA',
    selectable: true,
  },
  {
    source: 'order_assembly_cost',
    sortable: false,
    title: 'Cost',
    selectable: true,
  },
  {
    source: 'order_assembly_price',
    sortable: false,
    title: 'Price',
    selectable: true,
  },
  {
    source: 'history',
    sortable: false,
    title: 'History',
    selectable: true,
  },
];

export default coOrdersTable;
